PJQ.models.contacts.ContactImportUpload = PJQ.models.BaseModel.extend({
    defaults: {
        isFileAPI: true
    },
    idAttribute: 'contactImportUploadId',
    endpoint: function (urlOptions) {
        let params = [];
        if (urlOptions != null) {
            if (urlOptions.overwrite) {
                params.push({
                    parameter: 'overwrite',
                    value: true
                });
            } else if (urlOptions.skip) {
                params.push({
                    parameter: 'skip',
                    value: true
                });
            }

            if (urlOptions.createGroups) {
                params.push({
                    parameter: 'createGroups',
                    value: true
                });
            }
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'imports',
                value: this.id
            }
        ], params);
    },
    parse: function (model) {
        this.columns = new PJQ.collections.contacts.ContactImportUploadColumns(model ? model.columns : null);
        return model;
    }
});

PJQ.collections.contacts.ContactImportUploads = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ContactImportUpload,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'imports'
            }
        ]);
    }
});

PJQ.models.contacts.ContactImportUploadColumn = PJQ.models.BaseModel.extend({
    idAttribute: 'index',
    parse: function (model) {
        if (model && model.customField != null) {
            this.customField = new PJQ.models.customFields.CustomField(model.customField);
        }
        return model;
    }
});

PJQ.collections.contacts.ContactImportUploadColumns = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ContactImportUploadColumn
});

PJQ.views.contacts.ContactsImportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Contacts-Import'),
        minWidth: '70%',
        maxWidth: '90%',
        contextUpload: null
    },
    events: {
        'click .btn-export-template': 'exportTemplate',
        'click .btn-import': 'import',
        'click .btn-cancel': 'cancel'
    },
    renderData: function () {
        return {
            contextUpload: this.options.contextUpload
        };
    },
    afterRender: function () {
        if (this.collection == null) {
            this.collection = new PJQ.collections.contacts.ContactImportUploads();
            this.collection.fetch({
                success: _.bind(function () {
                    this.renderUI();
                }, this)
            });
        } else {
            this.renderUI();
        }
    },
    renderUI: function () {
        if (this.options.contextUpload != null) {
            this.renderUploadEdit();
        } else {
            this.renderImportUploadPicker();
        }
    },
    renderImportUploadPicker: function () {
        let $container = this.$('.contacts-import-container');
        new PJQ.views.contacts.ContactsImportUploadsSelect({
            el: $container,
            collection: this.collection,
            viewImportUploadCallback: _.bind(function (upload) {
                upload.fetch({
                    success: _.bind(function () {
                        $container.empty();
                        new PJQ.Loader($container);
                        this.options.contextUpload = upload;
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    renderUploadEdit: function () {
        let $container = this.$('.contacts-import-container');
        this.editor = new PJQ.views.contacts.ContactsImportUploadEdit({
            el: $container,
            model: this.options.contextUpload,
            onDone: _.bind(function () {
                this.collection.fetch({
                    success: _.bind(function () {
                        this.options.contextUpload = null;
                        this.render();
                    }, this)
                });
            }, this),
            onCancel: _.bind(function () {
                this.renderImportUploadPicker();
            }, this)
        });
    },
    exportTemplate: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'imports'
            },
            {
                endpoint: 'template'
            }
        ]));
    },
    import: function () {
        this.editor.import();
    },
    cancel: function () {
        this.options.contextUpload = null;
        this.render();
    }
});

PJQ.views.contacts.ContactsImportUploadsSelect = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Import-Uploads-Select')
    },
    events: {
        'click .view-contact-import-upload': 'viewImportUpload',
        'click .delete-contact-import-upload': 'deleteImportUpload'
    },
    beforeRender: function () {
        this.renderData = {
            collection: this.collection
        };
    },
    afterRender: function () {
        this.renderUploads();
        this.renderFileUploader();
    },
    renderUploads: function () {
        _.each(this.collection.models, function (model) {
            model.set('displayUploadedOn', PJQ.helpers.dateHelpers.getDateString(new Date(model.get('uploadedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME))
        });

        this.uploadsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.contacts-import-upload-data-table'),
            data: this.collection.models,
            language: {
                zeroRecords: "You haven't uploaded any contact imports yet"
            },
            isHideSearch: true,
            columns: [
                {"data": "attributes.fileName", "title": "File Name"},
                {"data": "attributes.uploadedBy", "title": "Uploaded By"},
                {"data": "attributes.displayUploadedOn", "title": "Uploaded On"},
                {
                    "title": "",
                    "width": "80px",
                    "orderable": false,
                    "searchable": false,
                    "render": function (data, type, row) {
                        let status = row.get('status');
                        if (status === 1) {
                            return '<span class="text-info fs-16 font-weight-light">Processing...</span>';
                        } else if (status === 2) {
                            return '<span class="text-success fs-16 font-weight-light">Imported</span>';
                        } else {
                            return '<div class="text-align-center"><button type="button" class="btn btn-info view-contact-import-upload mr-1"><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger delete-contact-import-upload"><i class="fal fa-trash"></i></button></div>';
                        }
                    }
                }
            ],
            onRowDoubleClick: _.bind(function (row) {
                let im = row.data();
                if (im.get('status') === 0) {
                    this.options.viewImportUploadCallback(im);
                }
            }, this)
        });
    },
    renderFileUploader: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.contacts-import-file-upload'),
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts'
                },
                {
                    endpoint: 'imports'
                }
            ]),
            isRemoveOnComplete: true,
            onSuccess: _.bind(function () {
                this.collection.fetch({
                    success: _.bind(function () {
                        this.renderUploads();
                    }, this)
                })
            }, this)
        });
    },
    viewImportUpload: function (e) {
        let row = this.uploadsDataTable.getRow($(e.currentTarget).parents('tr'));
        this.options.viewImportUploadCallback(row.data());
    },
    deleteImportUpload: function (e) {
        let row = this.uploadsDataTable.getRow($(e.currentTarget).parents('tr')),
            upload = row.data();

        upload.destroy();
        this.collection.remove(upload);
        row.remove();
        this.uploadsDataTable.refresh();
    }
});

PJQ.views.contacts.ContactsImportUploadEdit = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Import-Uploads-Edit')
    },
    events: {
        'click .btn-map-groups': 'mapGroups',
        'click .delete-contact-import-upload-row': 'deleteRow',
        'click .btn-edit-groups': 'editGroups',
        'click .btn-edit-work-areas': 'editWorkAreas',
        'keyup .input-text': 'textValueChanged',
        'keydown .input-int': 'numbersOnly',
        'keyup .input-int': 'intValueChanged',
        'change select.input-state': 'stateValueChanged',
        'change select.input-country': 'countryValueChanged',
        'keyup .input-phone': 'phoneValueChanged',
        'change select.input-bool': 'boolValueChanged',
        'change select.input-choice': 'singleChoiceValueChanged',
        'change select.input-user-type': 'userTypeValueChanged'
    },
    afterRender: function () {
        PJQ.app.session.fetchUserGroups(null, _.bind(function (groups) {
            this.groups = groups;

            _.each(this.model.get('rows'), _.bind(function(row) {
                _.each(PJQ.app.session.userTypes.getByIsCompany(false), _.bind(function (userType) {
                    if (_.size(row.columnData.userTypeId) > 0 && userType.get('name').toLowerCase() === row.columnData.userTypeId.toLowerCase().trim() ||
                        userType.get('userTypeId') === parseInt(row.columnData.userTypeId))
                        row.columnData.userTypeId = userType.get('userTypeId');
                }, this));
            }, this));

            this.renderImportUploadData();
        }, this));

        this.$el.closest('.modal').find('.cb-overwrite').on('change', _.bind(this.overwriteOptionChanged, this));
    },
    deleteRow: function (e) {
        let $target = $(e.currentTarget),
            row = this.dataTable.getRow($target.closest('tr'));
        this.dataTable.removeRow(row);
        this.model.set('rows', _.filter(this.model.get('rows'), function (exRow) {
            return exRow.index !== row.data().index;
        }));
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e);
    },
    textValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = $target.val();
    },
    intValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr')),
            parsedVal = parseInt($target.val());
        row.data().columnData[attr] = isNaN(parsedVal) ? 0 : parsedVal;
    },
    stateValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = $target.val();
    },
    countryValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            country = $target.val();

        if (country !== row.data().columnData[attr]) {
            let $state = $row.find('.input-state'),
                $options = this.getStateOptions(country, $state.val());
            $state.empty();
            $state.append($options);

            PJQ.helpers.inputHelpers.inputMaskZip($row.find('.input-zip'), country);
        }

        row.data().columnData[attr] = country;
    },
    getUserTypeOptions: function(selectedUserTypeId) {
        let options = '<option value="">Select Value</option>';

        _.each(PJQ.app.session.userTypes.getByIsCompany(false), _.bind(function(userType) {
            options += '<option ' + (selectedUserTypeId === userType.get('userTypeId') ? 'selected' : '') + ' value="' + userType.get('userTypeId') + '">' + userType.get('name') + '</option>';
        }, this));

        return options;
    },
    userTypeValueChanged: function (e) {
        let $target = $(e.currentTarget),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData['userTypeId'] = $target.val();
    },
    getStateOptions: function (country, selectedState) {
        let options = '<option value="">Select Value</option>';
        _.each(PJQ.constants.states[_.size(country) === 0 ? "us" : country.toLowerCase()], function (state) {
            let lowerAbbr = state.abbreviation.toLowerCase();
            options += '<option ' + (selectedState === lowerAbbr || selectedState === state.name.toLowerCase() ? 'selected' : '') + ' value="' + lowerAbbr + '">' + state.abbreviation.toUpperCase() + '</option>';
        });
        return options;
    },
    phoneValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = PJQ.helpers.formatHelpers.numbersOnly($target.val());
    },
    boolValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = $target.val() === 'true';
    },
    singleChoiceValueChanged: function (e) {
        let $target = $(e.currentTarget),
            attr = $target.data('p-bind'),
            row = this.dataTable.getRow($target.closest('tr'));
        row.data().columnData[attr] = $target.val();
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        };
    },
    getColumnWidth: function (column) {
        let width = null;
        switch (column.get('attribute').toLowerCase()) {
            case 'companyname':
            case 'contactname':
                width = '150px';
                break;
            case 'title':
                width = '100px';
                break;
            case 'email':
                width = '200px';
                break;
            case 'address1':
            case 'address2':
                width = '120px';
                break;
            case 'notes':
                width = '200px';
                break;
            case 'groups':
                width = '100px';
                break;
        }

        if (width == null) {
            switch (column.get('type').toLowerCase()) {
                case 'choice':
                    width = '80px';
                    break;
                case 'int':
                    width = '60px';
                    break;
                case 'bool':
                    width = '50px';
                    break;
                case 'phone':
                    width = '100px';
                    break;
                case 'text':
                    width = '100px';
                    break;
                case 'regions':
                case 'groups':
                case 'workareas':
                    width = '80px';
                    break;
                case 'state':
                case 'country':
                case 'zip':
                    width = '50px';
                    break;
                case 'usertype':
                    width = '85px';
                    break;
            }
        }
        return width;
    },
    renderImportUploadData: function () {
        this.unmatchedGroups = [];
        let columns = [],
            noEmailOrFax = false;
        _.each(this.model.columns.models, function (column) {
            let attrCamel = PJQ.helpers.objectHelpers.convertObjectCamelcase(column.get('attribute'));
            columns.push({
                data: "columnData." + attrCamel,
                title: column.get('name'),
                width: this.getColumnWidth(column),
                render: _.bind(function (data, type, row) {
                    if (type === 'sort' || type === 'type')
                        return data;

                    let input,
                        isValid = true;
                    switch (column.get('type').toLowerCase()) {
                        case 'choice':
                            if (column.customField != null) {
                                let options = '<option value="">No Value</option>';
                                _.each(column.customField.choices.models, function (choice) {
                                    let selected;
                                    if (PJQ.helpers.objectHelpers.refinedType(data) === 'array') {
                                        selected = data && data.indexOf(choice.id) !== -1;
                                    } else {
                                        selected = data === choice.id;
                                    }
                                    options += '<option ' + (selected ? 'selected' : '') + ' value="' + choice.id + '">' + choice.get('choiceName') + '</option>';
                                });

                                input = '<div class="d-flex align-items-center ht-100 wd-100"><select data-p-bind="' + attrCamel + '" class="form-control max-wd-150p input-choice ' + (column.customField.get('isMultipleChoice') ? 'input-multiple-choice' : '') + '">';
                                input += options;
                                input += '</select>';
                                input += '</div>';
                            }
                            break;
                        case 'bool':
                            input = '<select class="form-control input-bool" data-p-bind="' + attrCamel + '">';
                            input += '<option value="">Select Value</option>';
                            input += '<option value="true" ' + (data === true ? 'selected' : '') + '>Yes</option>';
                            input += '<option value="false" ' + (data === false ? 'selected' : '') + ' >No</option>';
                            input += '</select>';
                            break;
                        case 'state':
                            let selectedState = data != null ? data.toLowerCase() : '';
                            input = '<select class="form-control max-wd-150p input-state">';
                            input += this.getStateOptions(row.columnData.country, selectedState);
                            input += '</select>';
                            break;
                        case 'usertype':
                            input = '<select class="form-control max-wd-100p input-user-type">';
                            input += this.getUserTypeOptions(row.columnData.userTypeId);
                            input += '</select>';
                            break;
                        case 'zip':
                            isValid = !(_.size(data) > 0 && !PJQ.helpers.validators.validateZip(data));
                            input = '<input title="original: ' + data + '" type="text" data-p-bind="' + attrCamel + '" class="form-control input-text input-zip' + (!isValid ? ' bg-danger-transparent' : '') + '" value="' + (data != null ? data : "") + '">';
                            break;
                        case 'country':
                            let country = data != null ? data.toLowerCase() : '';
                            input = '<select title="original: ' + data + '" class="form-control input-country" data-p-bind="' + attrCamel + '"><option value="US" ' + (country === 'us' ? 'selected' : '') + '>US</option><option value="CA" ' + (country === 'ca' ? 'selected' : '') + ' >CA</option></select>';
                            break;
                        case 'int':
                            input = '<input title="original: ' + data + '" type="number" data-p-bind="' + attrCamel + '" class="form-control input-int" value="' + (data != null ? data : "") + '">';
                            break;
                        case 'phone':
                            isValid = true;
                            if (column.get('attribute').toLowerCase() === "fax" || column.get('attribute').toLowerCase() === "email") {
                                isValid = _.size(row.columnData.email) > 0 || _.size(row.columnData.fax) > 0;
                                noEmailOrFax = noEmailOrFax || !isValid;
                            }
                            input = '<input type="text" title="original: ' + data + '"  data-p-bind="' + attrCamel + '" class="form-control input-phone' + (!isValid ? ' bg-danger-transparent' : '') + '" value="' + (data != null ? data : "") + '">';
                            break;
                        case 'groups':
                            let matchResult = this.getColumnGroupNames(data),
                                pf = _.size(matchResult.unmatched) > 0;
                            this.unmatchedGroups = _.union(this.unmatchedGroups, matchResult.unmatched)
                            input = '<div class="d-flex align-items-center wd-100 ht-100 ' + (pf ? 'bg-primary-transparent' : '') + '"><button type="button" title="original: ' + data + '" class="btn btn-link btn-edit-groups">' + _.size(matchResult.matched).toString() + ' selected</button>';
                            if (pf) {
                                input += '<i class="fad fa-history ml-1" title="original: ' + data + '"></i>';
                            }
                            input += '</div>';
                            break;
                        case 'regions':
                            let regions = data != null ? data.split(',') : [];
                            input = '<button type="button" title="original: ' + data + '" class="btn btn-link btn-edit-regions">' + _.size(regions).toString() + ' selected</button>';
                            break;
                        case 'workareas':
                            input = '<button type="button" class="btn btn-link btn-edit-work-areas">' + _.size(data).toString() + ' selected</button>';
                            break;
                        case 'text':
                        default:
                            let rowVal = data;
                            isValid = true;
                            if (column.get('attribute').toLowerCase() === "fax" || column.get('attribute').toLowerCase() === "email") {
                                if (column.get('attribute').toLowerCase() === "email" && rowVal != null && rowVal.indexOf('<') !== -1 && rowVal.indexOf('>') !== -1) {
                                    let regexp = /<(.*?)>/g;
                                    rowVal = regexp.exec(rowVal)[1];
                                }

                                isValid = _.size(rowVal) > 0 || _.size(row.columnData.fax) > 0;
                                noEmailOrFax = noEmailOrFax || !isValid;
                            }
                            input = '<input type="text" title="original: ' + data + '"  data-p-bind="' + attrCamel + '" class="form-control input-text' + (!isValid ? ' bg-danger-transparent' : '') + '" value="' + (rowVal != null ? rowVal : "") + '">';
                            break;
                    }
                    return input;
                }, this)
            });
        }, this);
        columns.push({
            title: "",
            defaultContent: '<button type="button" class="btn btn-danger delete-contact-import-upload-row"><i class="fal fa-trash"></i></button>',
            orderable: false,
            searchable: false
        });

        _.each(this.model.get('rows'), function (row) {
            if (row.columnData.groups != null && row.columnData.groups.indexOf(',') === -1 && row.columnData.groups.indexOf('|') === -1) {
                row.columnData.groups = row.columnData.groups + ',';
            }
        });

        let $table = this.$('.contact-import-upload-data-table'),
            self = this;
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: $table,
            rowId: "index",
            autoWidth: false,
            isHideSearch: true,
            data: this.model.get('rows'),
            columns: columns,
            isOverflowAuto: true,
            onTableDraw: function () {
                PJQ.helpers.inputHelpers.inputMaskPhone($table.find('.input-phone'));
                $table.find('.input-multiple-choice').each(function () {
                    let attr = $(this).data('p-bind');
                    new PJQ.inputs.Selectpicker({
                        el: $(this),
                        isMultiple: true,
                        onChange: _.bind(function (value) {
                            let row = self.dataTable.getRow($(this).parents('tr'));
                            row.data().columnData[attr] = value;
                        }, this)
                    });
                });

                $table.find('th').each(function (index) {
                    let column = self.model.columns.models[index];
                    if (column != null) {
                        $(this).css('min-width', self.getColumnWidth(column));
                    }
                });

                let umGroups = _.size(self.unmatchedGroups) > 0;
                if ((umGroups || noEmailOrFax) && self.importAlert == null) {
                    let message = '';
                    if (noEmailOrFax) {
                        message += "Some of the imported contacts do not have an email or fax number, these are highlighted in red.";
                    }
                    if (umGroups) {
                        if (_.size(message) > 0) {
                            message += '<br/>'
                        }
                        let groupLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL);
                        message += 'Some of the imported contacts have groups that do not exist in the system.  If you do not map them by clicking <strong><a href="javascript:void(0)" class="btn-map-groups">Map ' + (groupLabel ? groupLabel : 'Groups') + '</a></strong>, these groups will be created automatically.';
                    }

                    self.importAlert = new PJQ.Alert(self.$el, {
                        type: 'primary',
                        text: message,
                        isPrepend: true
                    })
                }
            }
        });

        let $footer = this.$el.closest('.modal-content').find('.modal-footer');
        $footer.find('.btn-map-groups').remove();
        if (_.size(this.unmatchedGroups) > 0) {
            let groupLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL),
                $btn = $('<button />', {
                    type: 'button',
                    class: 'btn btn-info btn-map-groups',
                    text: 'Map ' + (groupLabel ? groupLabel : 'Groups')
                });
            $footer.prepend($btn);
            $btn.on('click', _.bind(this.mapGroups, this))
        }
    },
    editWorkAreas: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            data = row.data(),
            collection = new PJQ.collections.workAreas.ContactWorkAreas();

        _.each(this.model.get('workAreas'), function (workArea) {
            if (data.columnData.workAreas.indexOf(workArea.workAreaId) !== -1) {
                collection.add(new collection.model(workArea));
            }
        });

        new PJQ.views.workAreas.WorkAreaMapModal({
            collection: collection,
            onSave: _.bind(function (workAreaCol) {
                data.columnData.workAreas = _.map(workAreaCol.models, function (workArea) {
                    return workArea.get('workAreaId');
                });
                this.dataTable.refresh();
            }, this)
        });
    },
    getColumnGroupNames: function (data) {
        let groupNames,
            result = {
                matched: [],
                unmatched: []
            };
        if (_.size(data) === 0) {
            groupNames = [];
        } else if (data.indexOf('|') !== -1) {
            groupNames = data.split('|');
        } else if (data.indexOf(',') !== -1) {
            groupNames = data.split(',');
        } else {
            groupNames = [data];
        }
        _.each(groupNames, function (groupName) {
            if (groupName == null || _.size(groupName.trim()) === 0) {
                return;
            }

            let loweredName = groupName.toLowerCase().trim();
            if (_.find(this.groups.models, function (group) {
                return group.get('groupName').toLowerCase() === loweredName;
            }) != null) {
                result.matched.push(groupName);
            } else {
                let mappedGroup = _.find(this.groupMap, function (map) {
                    return map.group != null && map.groupName === groupName;
                });
                if (mappedGroup != null) {
                    result.matched.push(mappedGroup.group.get('groupName'));
                } else if (result.unmatched.indexOf(groupName) === -1) {
                    result.unmatched.push(groupName);
                }
            }
        }, this);
        return result;
    },
    editGroups: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            data = row.data(),
            selectedGroupIds = [],
            matchResult = this.getColumnGroupNames(data.columnData.groups);
        _.each(matchResult.matched, function (groupName) {
            let group = _.find(this.groups.models, function (group) {
                return group.get('groupName').toLowerCase() === groupName.trim().toLowerCase();
            });
            if (group != null) {
                selectedGroupIds.push(group.id);
            }
        }, this);
        new PJQ.views.groups.SelectGroupsModal({
            selectorOptions: {
                selectedGroupIds: selectedGroupIds
            },
            onSave: _.bind(function (groups) {
                data.columnData.groups = _.map(groups.selected, function (group) {
                    return group.get('groupName');
                }).join(',');
                this.dataTable.refresh();
            }, this)
        });
    },
    mapGroups: function () {
        new PJQ.views.contacts.MapGroupsModal({
            groupMap: this.groupMap,
            groupNames: this.unmatchedGroups,
            onSave: _.bind(function (map) {
                this.groupMap = map;
                this.render();
            }, this)
        });
    },
    editRegions: function () {

    },
    getIsOverwrite: function () {
        return this.$el.closest('.modal').find('.cb-overwrite').prop('checked') === true;
    },
    overwriteOptionChanged: function () {
        let $mdOuter = this.$el.closest('.modal').find('.cb-merge-data-outer');
        if (this.getIsOverwrite()) {
            $mdOuter.removeClass('hidden');
        } else {
            $mdOuter.addClass('hidden');
        }
    },
    import: function (importOptions) {
        let save = _.bind(function () {
            let $btn = this.$el.closest('.modal').find('.btn-import,.btn-cancel'),
                importLoader = new PJQ.Loader(this.dataTable.$el);
            $btn.prop('disabled', true);

            if (this.groupMap != null) {
                _.each(this.model.get('rows'), function (row) {
                    let matchResult = this.getColumnGroupNames(row.columnData.groups),
                        newNames = [];
                    _.each(matchResult.matched, function (gName) {
                        if (newNames.indexOf(gName) === -1) {
                            newNames.push(gName);
                        }
                    });

                    _.each(matchResult.unmatched, function (gName) {
                        if (newNames.indexOf(gName) === -1) {
                            newNames.push(gName);
                        }
                    });
                    if (_.size(newNames) > 0) {
                        row.columnData.groups = newNames.join('|');
                    }
                }, this)
            }

            let overwrite = this.getIsOverwrite();
            this.model.save({
                overwrite: overwrite,
                mergeData: overwrite && this.$el.closest('.modal').find('.cb-merge-data').prop('checked'),
                rows: this.model.get('rows')
            }, {
                timeout: 600000,
                urlOptions: _.extend(importOptions, {
                    createGroups: this.$('.cb-create-groups').prop('checked')
                }),
                notify: false,
                success: _.bind(function (model, data) {
                    PJQ.notifications.notify.successNotify({
                        message: "Your contacts have been queued for import"
                    });
                    if (typeof this.options.onDone === 'function') {
                        this.options.onDone();
                    }
                }, this)
            });
        }, this);
        if (importOptions == null || !importOptions.overwrite) {
            let noEmailFaxCount = 0;
            _.each(this.model.get('rows'), function (contact) {
                if (_.size(contact.columnData.email) === 0 && _.size(contact.columnData.fax) === 0) {
                    noEmailFaxCount++;
                }
            });
            if (noEmailFaxCount > 0) {
                new PJQ.views.modals.YesNo({
                    header: "Import Data Missing",
                    body: "Some of the contacts you are importing do not have an email or fax.  Do you still want to continue?",
                    onYes: _.bind(function () {
                        save();
                    }, this)
                });
            } else {
                save();
            }
        } else {
            save();
        }
    }
});

PJQ.views.contacts.DuplicateEmailModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Contacts-Import-Duplicate-Email'),
        onSkip: null,
        onOverwrite: null
    },
    events: {
        'click .btn-overwrite': 'overwrite',
        'click .btn-skip': 'skip',
        'click .btn-cancel': 'cancel'
    },
    overwrite: function () {
        if (typeof this.options.onOverwrite === 'function') {
            this.options.onOverwrite();
            this.removeModal();
        }
    },
    skip: function () {
        if (typeof this.options.onSkip === 'function') {
            this.options.onSkip();
            this.removeModal();
        }
    },
    cancel: function () {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
            this.removeModal();
        }
    }
});

PJQ.views.contacts.MapGroupsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-contacts-import-map-groups')
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        if (this.options.groupMap == null) {
            this.options.groupMap = [];
            _.each(this.options.groupNames, function (groupName) {
                this.options.groupMap.push({
                    id: _.uniqueId(),
                    groupName: groupName,
                    group: null
                });
            }, this);
        }

        PJQ.app.session.fetchUserGroups(null, _.bind(function (groups) {
            this.groups = groups;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            groupMap: this.options.groupMap,
            groups: this.groups
        };
    },
    afterRender: function () {
        let groupLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL);
        _.each(this.options.groupMap, function (map) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-group[data-tid="' + map.id.toString() + '"]'),
                defaultValue: map.group?.id,
                noneSelectedText: 'Select Group',
                isLiveSearch: true,
                onChange: _.bind(function (groupId) {
                    map.group = this.groups.get(groupId);
                }, this)
            });
        }, this);
    },
    save: function () {
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.options.groupMap);
            this.removeModal();
        }
    }
});